import styled from "@emotion/styled";
import { text } from "@atlas-int/tokens";
import GenericSelectBox from "../dropdownPrimitive/SelectBoxPrimitive";
import type {
  SelectBoxItem,
  ItemRenderProps,
} from "../dropdownPrimitive/types";
import {
  SelectBoxContainer,
  DropdownContainer,
  ToggleButton,
  ArrowUp,
  ArrowDown,
  MainMenu,
} from "./styles";

export type YearItemRenderProps = ItemRenderProps;

const SelectedItemLabel = styled.span`
  width: 100%;
  padding: 1px 2px 1px 6px;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  color: ${text.primary};
`;

const components = {
  SelectBoxContainer,
  DropdownContainer,
  ToggleButton,
  ArrowUp,
  ArrowDown,
  MainMenu,
  SelectedItemLabel,
};

interface YearSelectBoxInput {
  items: SelectBoxItem[];
  hashFunction: (item: SelectBoxItem) => string | number;
  placeholder: string;
  ItemRenderComponent: React.ComponentType<ItemRenderProps>;
  onChangeEvent:
    | ((args: { value: string | number }) => void)
    | undefined;
  selectedValueFromStore: SelectBoxItem | undefined;
}

const SelectBox = ({
  selectedValueFromStore,
  placeholder: _placeholder,
  ...props
}: YearSelectBoxInput) => (
  <GenericSelectBox
    {...props}
    matchSelectedItem={selectedValueFromStore}
    components={components}
  />
);

export default SelectBox;
